/**
 * Has something changed for this account that the devices frame does not show?
 *
 * WHY THIS EXISTS — owner, 2026-10-07: 我發現當一個裝置 pin agent 之後, 另一個裝置的狀態
 * 不會同步. 需要重啟才會同步.
 *
 * A pin on another device always rang the account bell, and the bell always arrived
 * here as a devices frame. But the re-read of the pins sat behind devicesChanged.ts,
 * which — rightly — does nothing for a frame that says nothing new about the machines,
 * and a pin changes nothing about a machine. So the bell was heard and dropped. The
 * friend graph rode the same path and was dropped the same way.
 *
 * Re-reading on every frame is not the fix: frames arrive every couple of seconds on an
 * idle account. The cloud now says WHEN: `account_rev` moves on a pin or friend write
 * and on nothing else.
 *
 * The first value seen is a baseline, not news — the queries it guards have just been
 * fetched by whoever mounted them. After that any DIFFERENT value is news, including
 * one seen on a reopened socket: that is how a device learns what it missed while away.
 */
export function makeAccountRevHandler(onChange: () => void): (rev: string) => void {
  let last: string | null = null
  return (rev: string) => {
    if (rev === last) return
    const first = last === null
    last = rev
    if (!first) onChange()
  }
}
